import { useGenericSelector } from "../../Shared/Redux";
import { IApiCallState } from "../ApiCalls/Models";
import { hydrateApiCallState } from "../ApiCalls/Utils";
import { ISettings, IStop, ITravel } from "../Models";

export interface IAppSettings extends ISettings
{
	from: string[];
	to: string[];
	dinnerOptions?: string[];
	lunchOptions?: string[];
}
export const getApiCallState = () => hydrateApiCallState(useStateSelector(state => state.apicalls));
export function useStateSelector<T>(selectorFunc: (state: ISkinetworksAppstate) => T) { return useGenericSelector((state :ISkinetworksAppstate) => selectorFunc(state)); }

export interface ISkinetworksAppstate
{
	booking: ITablebookingState;
	apicalls: IApiCallState;
}

export interface ITablebookingState
{
	allowedFrom?: string[];
	allowedTo?: string[];
	defaultFrom?: string;
	defaultTo?: string;
	stops?: IStop[];
	origin?: IStop;
	destination?: IStop;
	departureDate?: string;
	returnDate?: string;
	travels?: ITravel[];
	customerDetails?: ICustomerDetails;
	dinnerOptions?: string[];
	lunchOptions?: string[];
	availableTimes?: string[];
	tableBookings?: ITableBooking[];
}

export interface ICustomerDetails
{
	firstname?: string;
	lastname?: string;
	email?: string;
	phone?: string;
	bookingNumber?: string;
}

export interface ITableBooking
{
	id: number;
	arrival: string;
	persons: number;
	travelId?: string;
	slot?: string;
}